module.exports = __webpack_public_path__ + "static/media/000_insti.3e759028.jpg";